import React, { Fragment } from 'react';

import UniversalInput from '../../../../../../lib/wrappers/UniversalInput';

import { INPUT_TYPES } from '../../../../../../constants/inputs/inputTypes';
import { DROPDOWN_OPTIONS } from '../../../../../../constants/ssap/hhmTypes/dropdownOptions';
import { VALIDATION_TYPES } from '../../../../../../constants/inputs/validationTypes';
import { omit } from '../../../../../../utils/miscellaneous/objectHelpers';


const RepresentativeAddressInputs = props => {

    const {
        postalCode,
        countyCode,
        streetAddress1,
        streetAddress2,
        state,
        city,
        currentData,
        counties,
        isInputStandalone = false,
        ...restProps
    } = props;

    const cleanedRestProps = omit(restProps, 'children');

    return (
        <Fragment>
            <UniversalInput
                label={{
                    text: 'ssap.input.label.address_line_one',
                    isLabelRequired: true
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'streetAddress1',
                    helperClasses: [],
                    value: streetAddress1,
                    placeholder: 'ssap.input.placeholder.address_line_one',
                    validationType: VALIDATION_TYPES.ADDRESS_LINE1,
                    currentData: currentData,
                    fields: ['address'],
                    isInputStandalone
                }}
                errorClasses={['grid-offset-4']}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.address_line_two',
                    isLabelRequired: false
                }}
                inputData={{
                    isInputRequired: false,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'streetAddress2',
                    helperClasses: [],
                    value: streetAddress2,
                    placeholder: 'ssap.input.placeholder.address_line_two',
                    validationType: VALIDATION_TYPES.ADDRESS_LINE2,
                    currentData: currentData,
                    fields: ['address'],
                    isInputStandalone
                }}
                errorClasses={['grid-offset-4']}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.city',
                    isLabelRequired: true
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'city',
                    helperClasses: [],
                    value: city,
                    placeholder: 'ssap.input.placeholder.city',
                    validationType: VALIDATION_TYPES.CITY,
                    currentData: currentData,
                    fields: ['address'],
                    isInputStandalone
                }}
                errorClasses={['grid-offset-4']}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.zip',
                    isLabelRequired: true
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'postalCode',
                    helperClasses: [],
                    value: postalCode,
                    placeholder: 'ssap.input.placeholder.zip',
                    validationType: VALIDATION_TYPES.ZIP_CODE,
                    currentData: currentData,
                    fields: ['address'],
                    isInputStandalone
                }}
                errorClasses={['grid-offset-4']}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.state',
                    isLabelRequired: true
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.DROPDOWN,
                    name: 'state',
                    value: state,
                    options: DROPDOWN_OPTIONS.STATE,
                    validationType: VALIDATION_TYPES.CHOSEN,
                    currentData: JSON.parse(JSON.stringify(currentData)),
                    fields: ['address'],
                    isInputStandalone
                }}
                errorClasses={['grid-offset-4']}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.county',
                    isLabelRequired: true
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.DROPDOWN,
                    name: 'countyCode',
                    value: countyCode,
                    options: DROPDOWN_OPTIONS.COUNTIES_FOR_EXACT_ZIPCODE(counties),
                    validationType: VALIDATION_TYPES.CHOSEN,
                    currentData: currentData,
                    fields: ['address'],
                    isInputStandalone
                }}
                errorClasses={['grid-offset-4']}
                {...cleanedRestProps}
            />
        </Fragment>
    );
};

export default RepresentativeAddressInputs;
